import { Collapsible } from '../../../../elements/Collapsible';
import { Component } from '../../../../elements/Component';

interface INewStandardInfoState {
    isOpen: boolean;
}

export class NewStandardInfo extends Component<{}, INewStandardInfoState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }
    public render() {
        return (
            <Collapsible
                header="Classificatie van diabetische retinopathie"
                isOpen={this.state.isOpen}
                toggle={async (isOpen: boolean) => await this.setState({ isOpen })}
            >
                <table className="fundusscreening-new-standard-table">
                    <thead>
                        <tr>
                            <th>Classificatie</th>
                            <th>Beleid</th>
                            <th>Omschrijving</th>
                        </tr>
                        <tr className="table-header-divider">
                            <td colSpan={3}>
                                <div className="divider"></div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>R0 - Geen zichtbare retinopathie</td>
                            <td>Interval 2 of 3 jaar</td>
                            <td>
                                Eenmaal geen zichtbare retinopathie (R0); tweejaarlijkse screeningsinterval
                                <br></br>
                                Tweemaal achtereen geen zichtbare retinopathie (R0); driejaarlijkse screeningsinterval
                            </td>
                        </tr>
                        <tr>
                            <td>R1 - Milde achtergrondretinopathie</td>
                            <td>Interval 1 jaar</td>
                            <td>
                                Microaneurysmata en/of retinabloeding (puntvormige bloedingen of 'red dots', maximaal
                                10)
                            </td>
                        </tr>
                        <tr>
                            <td>R2 - Pre-proliferatief (matige tot ernstige non-proliferatieve retinopathie)</td>
                            <td>Verwijzing</td>
                            <td>
                                Multipele, ronde of vlekkige bloedingen en/of vastomlijnde IRMA en/of 'venous beading'
                                en/of reduplicatie
                            </td>
                        </tr>
                        <tr>
                            <td>R3 - Proliferatieve retinopathie</td>
                            <td>Snelle verwijzing</td>
                            <td>
                                Alle nieuwe vaten, pre-retinale fibrose, glasvocht- of pre-retinale bloeding met of
                                zonder loslating door tractie
                            </td>
                        </tr>
                        <tr className="table-header-divider">
                            <td colSpan={3}>
                                <div className="divider"></div>
                            </td>
                        </tr>
                        <tr>
                            <td>M0 - Geen zichtbare maculopathie</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>M1 - Maculopathie</td>
                            <td>Verwijzing</td>
                            <td colSpan={3}>
                                Gaat gepaard met R1, R2 of R3. Maculopathie: aanwezigheid van tweedimensionale
                                fotografische markers van diabetische maculopathie; Exsudaat binnen 1 disc diameter van
                                het centrum van de fovea, circinate- of groeps-exsudaten binnen de macula,
                                microaneurysma of bloeding binnen 1 disc diameter van het centrym van de fovea.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Collapsible>
        );
    }
}
